import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "contact");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Contact | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet> 

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="contact-container">
						<div className="title contact-title">
							¿Quieres conocer más de mí?
						</div>

						<div className="subtitle contact-subtitle">
							Gracias por su interés en ponerse en contacto con
							a mí. Agradezco sus comentarios, preguntas y
							sugerencias, si tiene una pregunta específica o
							comentario, no dude en contactarme directamente por mis redes sociales, puedes encontrarme en todas las que están a continuación.
							<br />
							{/*<a href={`mailto:${INFO.main.email}`} style={{ fontWeight: 'bold', textDecoration: 'none', color: 'black' }}>
								{INFO.main.email}
							</a>*/} 
							Hago un esfuerzo para responder a todos los mensajes dentro
							24 horas, aunque me puede llevar más tiempo dependiendo de lo ocupado que esté.
							
							{/*<a
								href={INFO.socials.linkedin}
								target="_blank"
								rel="noreferrer"
							>
								{INFO.socials.linkedin}
							</a>*/}
							&nbsp; Comparto actualizaciones periódicamente y me relaciono con mis
							seguidores allí, así que no dudes en contactarme.
							Gracias de nuevo por tú interés, y espero
							¡saber de ti!
						</div>
					</div>

					<div className="socials-container">
						<div className="contact-socials">
							<Socials />
						</div>
						
					</div>
					
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
